import { render, staticRenderFns } from "./story-card.vue?vue&type=template&id=0b3e1c46&"
import script from "./story-card.vue?vue&type=script&lang=js&"
export * from "./story-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports